import { Button, Alert, Modal } from "react-bootstrap"; 

function MessageBox(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton >
          <Modal.Title id="contained-modal-title-vcenter">
            {props.showerror?'Error!':'Success!'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant={props.showerror?'danger':'success'}>
            <p>
              {props.showerror?props.errmessage:props.succmessage}
            </p>
          </Alert> 
  
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  export default MessageBox;